export default function Go_Assignment () {
  return (
    <div>
      <h1>Go_Assignment </h1>
      <p>Assignment</p>
    </div>
  );
}